var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "menu-wrapper", attrs: { id: "categories-wrapper" } },
    [
      !_vm.hasPOSAccess
        ? _c("section", { staticClass: "content-container" }, [
            _c(
              "div",
              { staticClass: "access-denied-container" },
              [
                _c("h4", [_vm._v("POS Access Required")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n        Menu categories management is part of our POS system add-on. Please\n        upgrade your subscription to access this feature.\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { to: "/settings/billing" },
                  },
                  [_vm._v("\n        Upgrade Subscription\n      ")]
                ),
              ],
              1
            ),
          ])
        : _c(
            "div",
            [
              _c("alert-modal", {
                ref: "confirmDelete",
                attrs: { cancelable: "true", alertText: _vm.alertText },
                on: { confirm: _vm.confirmDelete },
              }),
              _vm._v(" "),
              _c(
                "b-card-group",
                { staticClass: "menu-card-group mb-4", attrs: { columns: "" } },
                [
                  _vm._l(_vm.localRecord, function (menu) {
                    return _c("b-card", { key: menu.id }, [
                      _c(
                        "div",
                        [
                          _vm.currentEdits[menu.id] == true
                            ? _c("toggle-button", {
                                staticClass: "active-toggle",
                                staticStyle: { "font-size": "12pt" },
                                attrs: {
                                  value: menu.is_active == 1,
                                  color: "#82C7EB",
                                  sync: true,
                                  labels: { checked: "on", unchecked: "off" },
                                  width: 65,
                                  height: 33,
                                },
                                on: {
                                  change: function ($event) {
                                    menu.is_active = $event.value ? true : false
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentEdits[menu.id] != true
                            ? _c(
                                "b-badge",
                                {
                                  staticClass: "menu-badge",
                                  attrs: {
                                    variant:
                                      menu.is_active == 1
                                        ? "success"
                                        : "secondary",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      menu.is_active == 1
                                        ? "active"
                                        : "inactive"
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "menu-actions" }, [
                        _vm.currentEdits[menu.id] != true
                          ? _c("i", {
                              staticClass: "fi-pencil",
                              on: {
                                click: function ($event) {
                                  return _vm.$set(
                                    _vm.currentEdits,
                                    menu.id,
                                    true
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentEdits[menu.id] == true
                          ? _c("i", {
                              staticClass: "fi-trash",
                              on: {
                                click: function ($event) {
                                  return _vm.startDelete(menu.id)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentEdits[menu.id] == true
                          ? _c("i", {
                              staticClass: "fi-save",
                              on: {
                                click: function ($event) {
                                  return _vm.updateMenu(menu)
                                },
                              },
                            })
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.currentEdits[menu.id] != true
                        ? _c(
                            "div",
                            [
                              _c("h4", [_vm._v(_vm._s(menu.name))]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(menu.description))]),
                              _vm._v(" "),
                              _c("br"),
                              _c("br"),
                              _vm._v(" "),
                              _vm._l(menu.menu_tag, function (tag) {
                                return _c(
                                  "div",
                                  { key: tag.id },
                                  [
                                    _c(
                                      "b-badge",
                                      { attrs: { variant: "info" } },
                                      [_vm._v(" " + _vm._s(tag.name) + " ")]
                                    ),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          )
                        : _c(
                            "div",
                            [
                              _c(
                                "info-row",
                                {
                                  staticClass: "info-main-row",
                                  attrs: { sizing: 2, title: "Name" },
                                },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "input-group",
                                      attrs: { sm: "12" },
                                    },
                                    [
                                      _c("b-form-input", {
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          title: "Name",
                                          placeholder: "Happy Hour Menu",
                                          value: menu.name,
                                          required: "",
                                        },
                                        model: {
                                          value: menu.name,
                                          callback: function ($$v) {
                                            _vm.$set(menu, "name", $$v)
                                          },
                                          expression: "menu.name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("Taggregator", {
                                ref: "tagsTaggregator",
                                refInFor: true,
                                attrs: {
                                  label:
                                    "select which tags to use for menu categories",
                                  items: _vm.getTags,
                                  selections: _vm.selectedTags[menu.id],
                                  minimum: 0,
                                  name: "tags",
                                  labelKey: "name",
                                  quickAddCallback: _vm.quickAddTag,
                                  quickAddDescription:
                                    "Please provide valid tag name",
                                  quickAddMinWordCount: 1,
                                  quickAddMinWordLength: 1,
                                  quickAddHasUniqueName: true,
                                },
                                on: {
                                  "update:selections": function ($event) {
                                    return _vm.$set(
                                      _vm.selectedTags,
                                      menu.id,
                                      $event
                                    )
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "result",
                                      fn: function ({ result }) {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "result-label" },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(result.name) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "selection",
                                      fn: function ({ selection }) {
                                        return [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(selection.name) +
                                              "\n            "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Menu Description",
                                    "label-for": "menuDescriptionTextArea",
                                  },
                                },
                                [
                                  _c("b-form-textarea", {
                                    attrs: {
                                      id: "menuDescriptionTextArea",
                                      type: "text",
                                      placeholder:
                                        "A delightful assortment of savory dishes...",
                                    },
                                    model: {
                                      value: menu.description,
                                      callback: function ($$v) {
                                        _vm.$set(menu, "description", $$v)
                                      },
                                      expression: "menu.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.allowCreateNew
                    ? _c(
                        "b-card",
                        {
                          staticClass: "mb-2",
                          attrs: { title: "Create New Menu" },
                          on: { click: _vm.createNewMenu },
                        },
                        [_vm._v("\n        +\n      ")]
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _vm.isRequesting
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        left: "0px",
                        top: "0px",
                        background: "rgba(255, 255, 255, 0.7)",
                      },
                    },
                    [_c("spinner-loader")],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }